import e from "./checkbox-group.vue2.js";
import { openBlock as r, createBlock as t, resolveDynamicComponent as p, withCtx as c, renderSlot as a } from "vue";
import n from "../../_virtual/_plugin-vue_export-helper.js";
function s(o, f, l, m, u, i) {
  return r(), t(p(o.tag), {
    class: "ap-checkbox-group",
    role: "group"
  }, {
    default: c(() => [
      a(o.$slots, "default")
    ]),
    _: 3
  });
}
const h = /* @__PURE__ */ n(e, [["render", s]]);
export {
  h as default
};
